import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export interface TempUserInfo {
  id: string;
  session_id: string;
  display_name: string;
  guest_number: number;
  created_at: string;
  expires_at: string;
}

export const useAdminTempUserInfo = (userId?: string) => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['admin-temp-user-info', userId],
    queryFn: async () => {
      // Temporary users feature disabled - requires additional database setup
      return null;
    },
    enabled: false,
  });
};

export const useAdminDisplayName = (userId?: string) => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['admin-display-name', userId],
    queryFn: async () => {
      // Display name lookup disabled - requires additional database setup
      return null;
    },
    enabled: false,
  });
};